import { Button } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ColumnsListCheckBox from '../../../../Components/CustomTabs/ColumnsList/ColumnsListCheckBox'
import { ReactComponent as FilterColumnIcon } from '../../../../Assets/filterColumns.svg';
import styles from './columnConfig.module.css'

interface ColumnConfigProps {
    headerNames: string[];
    fixedColumns: string[];
    visibleColumns: string[] | null;
    setVisibleColumns: React.Dispatch<React.SetStateAction<string[] | null>>;
}

export const ColumnConfig = (props: ColumnConfigProps) => {
    const { headerNames, fixedColumns, visibleColumns, setVisibleColumns } = props;
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);


    const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const isColumnVisible = (columnId: string) => visibleColumns && visibleColumns.includes(columnId);


    const AllBoxSelected = headerNames.length === (visibleColumns ?? []).length;

    const handleColumnToggle = (columnId: string) => {
        if (fixedColumns.includes(columnId)) {
            // Do not allow to hide fixed columns
            return;
        }

        setVisibleColumns((prev) => {
            if (!prev) {
                return prev;
            }

            return prev.includes(columnId)
                ? prev.filter((id) => id !== columnId)
                : [...prev, columnId]
        });
    };

    const handleSelectAll = () => {
        setVisibleColumns(headerNames);
    }

    const handleUnselectApp = () => {
        setVisibleColumns(fixedColumns);
    }

    useEffect(() => {
        if (headerNames?.length > 0 && visibleColumns === null) {
            setVisibleColumns([...fixedColumns])
        }
    }, [headerNames])
    return (
        <>
            <Button
                aria-controls={anchorEl ? 'column-menu' : undefined}
                aria-haspopup="true"
                onClick={handleMenuOpen}
                variant="outlined"
                disableRipple={true}
                classes={{ root: styles.filterBtn }}
            >
                <FilterColumnIcon />
            </Button>
            {
                (headerNames && anchorEl) &&
                <ColumnsListCheckBox
                    anchorEl={anchorEl}
                    handleMenuClose={handleMenuClose}
                    AllBoxSelected={AllBoxSelected}
                    handleUnselectApp={handleUnselectApp}
                    handleSelectAll={handleSelectAll}
                    handleColumnToggle={handleColumnToggle}
                    TotalTableInfo={headerNames}
                    fixedColumns={fixedColumns}
                    isColumnVisible={isColumnVisible}
                />
            }
        </>
    )
}
